var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import cloneDeep from 'lodash/cloneDeep';
import constants from './constants';

var PLOT_OPTIONS_BASE = {
    line: {
        lineWidth: 1
    },
    series: {
        turboThreshold: 2000
    }
};

var HISTOGRAM_PLOT_OPTIONS_BASE = {
    column: {
        pointPadding: 0,
        borderWidth: 0,
        groupPadding: 0,
        pointPlacement: 'between',
        shadow: false
    }
};

var SOLIDGAUGECHART_PLOT_OPTIONS_BASE = {
    solidgauge: {
        dataLabels: {
            borderWidth: 0,
            useHTML: false
        }
    }
};

var FUNNEL_PLOT_OPTIONS_BASE = {
    series: {
        neckWidth: '25%',
        neckHeight: '25%',
        width: '60%'
    },
    funnel: {
        borderColor: '#000000',
        borderWidth: 1,
        cursor: 'pointer'
    }
};

var COLUMN_WITH_TARGET_PLOT_OPTIONS_BASE = {
    column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
        groupPadding: 0
    }
};

var PYRAMID_PLOT_OPTIONS_BASE = {
    plotOptions: {
        series: {
            center: ['40%', '50%'],
            width: '80%'
        }
    },
    pyramid: {
        height: '80%',
        width: '60%',
        borderColor: '#000000',
        borderWidth: 1,
        cursor: 'pointer'
    }
};

var BULLET_CHART_PLOT_OPTIONS_BASE = {
    series: {
        pointPadding: 0.25,
        borderWidth: 0,
        color: '#000',
        targetOptions: {
            width: '200%'
        }
    }
};

var RADIALBAR_PLOT_OPTIONS_BASE = {
    column: {
        stacking: 'normal',
        borderWidth: 0,
        pointPadding: 0,
        groupPadding: 0.15,
        pointPlacement: 'between'
    }
};

var configurePlotOptions = function configurePlotOptions(widgetConfig, customConfig) {
    var ChartConfig = widgetConfig.ChartConfig,
        GaugeConfig = widgetConfig.GaugeConfig;


    if (widgetConfig.Type.toLowerCase() === 'bullet') {
        BULLET_CHART_PLOT_OPTIONS_BASE["series"]["color"] = widgetConfig.BulletConfig.Series[0]["Color"];
        return BULLET_CHART_PLOT_OPTIONS_BASE;
    }

    //if it's not a chart return the same static plot options
    if (!ChartConfig) {
        if (GaugeConfig && GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.SOLIDGAUGE) return SOLIDGAUGECHART_PLOT_OPTIONS_BASE;else if (GaugeConfig && GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.GAUGESERIES) return PLOT_OPTIONS_BASE;
        return HISTOGRAM_PLOT_OPTIONS_BASE;
    } else {
        if (ChartConfig.ChartType.toLowerCase() === constants.chartTypes.COLUMNWITHTARGET) return COLUMN_WITH_TARGET_PLOT_OPTIONS_BASE;else if (ChartConfig.ChartType.toLowerCase() === constants.chartTypes.FUNNEL) return FUNNEL_PLOT_OPTIONS_BASE;else if (ChartConfig.ChartType.toLowerCase() === constants.chartTypes.PYRAMID) return PYRAMID_PLOT_OPTIONS_BASE;else if (ChartConfig.ChartType.toLowerCase() === constants.chartTypes.RADIALBAR) return RADIALBAR_PLOT_OPTIONS_BASE;
    }

    var config = cloneDeep(PLOT_OPTIONS_BASE);
    config = _extends({}, config, cloneDeep(customConfig));

    return config;
};

export default configurePlotOptions;